document.addEventListener("DOMContentLoaded", () => {
  const flowers = document.querySelectorAll(".flower");
  let activeFlower = null;
  let activeTooltip = null;
  let hoverTimeout = null;

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function closeActive() {
    if (!activeFlower) return;
    activeFlower.classList.remove("active");
    if (activeTooltip) {
      activeTooltip.classList.remove("show");
      activeTooltip.classList.remove("tooltip-flipped");
      activeTooltip.innerHTML = "";
      activeTooltip.removeAttribute("style");
    }
    activeFlower = null;
    activeTooltip = null;
  }

  // Guardar listeners para poder quitarlos
  const listeners = [];

  function setupListeners() {
    // Quitar listeners anteriores
    listeners.forEach(({ el, type, fn }) => el.removeEventListener(type, fn));
    listeners.length = 0;

    flowers.forEach((flower, idx) => {
      const baseId = flower.dataset.tooltipId || `flower-tooltip-auto-${idx}`;
      const bodyTooltipId = baseId + "-flt";

      let tooltip = document.getElementById(bodyTooltipId);
      if (!tooltip) {
        tooltip = document.createElement("div");
        tooltip.id = bodyTooltipId;
        tooltip.className = "flower-tooltip";
        document.body.appendChild(tooltip);
      }

      function showTooltip(e) {
        if (activeFlower === flower || !tooltip) return;
        closeActive();

        const text = flower.dataset.text || "";
        const rect = flower.getBoundingClientRect();

        tooltip.innerHTML = "";
        const clone = flower.cloneNode(true);
        clone.removeAttribute("data-tooltip-id");
        clone.removeAttribute("data-text");
        clone.classList.remove("active");
        clone.classList.add("tooltip-icon-clone");
        clone.style.pointerEvents = "none";

        const textWrap = document.createElement("div");
        textWrap.className = "tooltip-text";
        textWrap.innerHTML = text;

        tooltip.appendChild(clone);
        tooltip.appendChild(textWrap);
        tooltip.classList.add("show");

        const tW = tooltip.offsetWidth;
        const tH = tooltip.offsetHeight;
        const padding = isMobile() ? 10 : 16;
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const margin = 20;

        const spaceRight = windowWidth - (rect.right + window.scrollX);
        const spaceLeft = rect.left + window.scrollX;
        
        const needsFlip = spaceRight < (tW - rect.width - padding + margin);
        
        tooltip.innerHTML = "";
        
        if (needsFlip) {
          tooltip.appendChild(textWrap);
          tooltip.appendChild(clone);
          tooltip.classList.add('tooltip-flipped');
        } else {
          tooltip.appendChild(clone);
          tooltip.appendChild(textWrap);
          tooltip.appendChild(clone);
          tooltip.appendChild(textWrap);
          tooltip.classList.remove('tooltip-flipped');
        }

        let tooltipLeft, tooltipTop;
        
        if (needsFlip) {
          const iconOffsetInTooltip = tW - padding - rect.width;
          tooltipLeft = rect.left + window.scrollX - iconOffsetInTooltip;
        } else {
          tooltipLeft = rect.left + window.scrollX - padding;
        }
        
        const iconVerticalOffset = (tH - rect.height) / 2;
        tooltipTop = rect.top + window.scrollY - iconVerticalOffset;

        const rightOverflow = tooltipLeft + tW - windowWidth;
        const bottomOverflow = tooltipTop + tH - (window.scrollY + windowHeight);
        
        if (rightOverflow > margin) {
          tooltipLeft = tooltipLeft - rightOverflow - margin;
        }
        
        if (bottomOverflow > margin) {
          tooltipTop = tooltipTop - bottomOverflow - margin;
        }
        
        if (tooltipLeft < margin) {
          tooltipLeft = margin;
        }
        
        if (tooltipTop < window.scrollY + margin) {
          tooltipTop = window.scrollY + margin;
        }

        tooltip.style.top = `${Math.round(tooltipTop)}px`;
        tooltip.style.left = `${Math.round(tooltipLeft)}px`;

        activeFlower = flower;
        activeTooltip = tooltip;
      }

      if (isMobile()) {
        const flowerClick = (e) => {
          e.stopPropagation();
          e.preventDefault();
          if (activeFlower === flower) {
            closeActive();
            return;
          }
          showTooltip(e);
        };
        const tooltipClick = (e) => {
          e.stopPropagation();
          closeActive();
        };
        flower.addEventListener("click", flowerClick);
        tooltip.addEventListener("click", tooltipClick);
        listeners.push({ el: flower, type: "click", fn: flowerClick });
        listeners.push({ el: tooltip, type: "click", fn: tooltipClick });
      } else {
        const flowerEnter = showTooltip;
        const flowerLeave = () => {
          hoverTimeout = setTimeout(closeActive, 100);
        };
        const tooltipEnter = () => {
          if (hoverTimeout) clearTimeout(hoverTimeout);
        };
        const tooltipLeave = () => {
          closeActive();
        };
        flower.addEventListener("mouseenter", flowerEnter);
        flower.addEventListener("mouseleave", flowerLeave);
        tooltip.addEventListener("mouseenter", tooltipEnter);
        tooltip.addEventListener("mouseleave", tooltipLeave);
        listeners.push({ el: flower, type: "mouseenter", fn: flowerEnter });
        listeners.push({ el: flower, type: "mouseleave", fn: flowerLeave });
        listeners.push({ el: tooltip, type: "mouseenter", fn: tooltipEnter });
        listeners.push({ el: tooltip, type: "mouseleave", fn: tooltipLeave });
      }
    });
  }

  setupListeners();

  document.addEventListener("click", (e) => {
    if (activeTooltip && activeTooltip.contains(e.target)) return;
    closeActive();
  });
  window.addEventListener("scroll", closeActive, { passive: true });
  window.addEventListener("resize", () => {
    closeActive();
    setupListeners();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeActive();
  });
});
